var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsvDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C3.895 0 3 0.895 3 2V7H2C0.895 7 0 7.895 0 9V14C0 15.105 0.895 16 2 16H3V18C3 19.105 3.895 20 5 20H13.1719L11.1719 18H5V16H15V14C15 12.895 15.895 12 17 12H19V5L14 0H5ZM5 2H13V6H17V7H5V2ZM4 9C5.105 9 6 9.895 6 11H5C5 10.449 4.551 10 4 10C3.449 10 3 10.449 3 11V12C3 12.551 3.449 13 4 13C4.551 13 5 12.551 5 12H6C6 13.105 5.105 14 4 14C2.895 14 2 13.105 2 12V11C2 9.895 2.895 9 4 9ZM8.64453 9C10.0675 9.041 10.1543 10.2829 10.1543 10.5039H9.1875C9.1875 10.4009 9.20491 9.80664 8.62891 9.80664C8.45391 9.80664 8.05984 9.88419 8.08984 10.3672C8.11884 10.8102 8.70355 11.0194 8.81055 11.0664C9.03455 11.1484 10.1414 11.6424 10.1504 12.6504C10.1524 12.8644 10.0971 13.985 8.66406 14C7.10506 14.017 7 12.6754 7 12.3984H7.97461C7.97461 12.5454 7.98706 13.2562 8.66406 13.2012C9.07106 13.1672 9.15983 12.8743 9.17383 12.6562C9.19683 12.2893 8.84656 12.0686 8.47656 11.8906C7.95656 11.6406 7.13414 11.3334 7.11914 10.3594C7.10614 9.48238 7.75053 8.975 8.64453 9ZM11 9H12.0527L12.9922 12.6465L13.9375 9H15L13.6465 14H12.3457L11 9ZM17 14V18H14L18 22L22 18H19V14H17Z",
    fill: "#FF9D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvDown);
export default __webpack_public_path__ + "static/media/csv-down.43e08857.svg";
export { ForwardRef as ReactComponent };